/**
 * Create → Q&A, step 1: propose the questionnaire's questions.
 *
 * Step 2 is the shared solution-run API (`createRun` with `kind: "qa"` and
 * `params.questions`); the run result's shape is declared with the page
 * (`features/solutions/create/qa/qaTypes.ts`), since the OpenAPI types a run
 * result as a kind-specific JSON object.
 */

import type { components } from "./_generated/schema";
import { apiFetch } from "./apiFetch";

export type QuestionExtraction = components["schemas"]["QuestionExtraction"];
export type ExtractedQuestion = components["schemas"]["ExtractedQuestion"];
export type ExtractQuestionsIn = components["schemas"]["ExtractQuestionsIn"];

/**
 * Propose the questions of an uploaded questionnaire — verbatim, in document
 * order — with the chosen model (`connection_id` + `deployment`, one of
 * `GET /ai/chat-models`; both null = the pinned platform deployment). The
 * upload is read, not consumed: pass the same `upload_id` (and model) to the
 * run. `404 solution_upload_not_found` (unknown / already used),
 * `404 ai_connection_not_found`, `400 ai_deployment_invalid`,
 * `422 questionnaire_unreadable`, `503 grounded_ai_unavailable`,
 * `502 ai_upstream_failure`.
 */
export function extractQuestions(
  token: string,
  uploadId: string,
  model: Omit<ExtractQuestionsIn, "upload_id"> = {},
): Promise<QuestionExtraction> {
  return apiFetch<QuestionExtraction>("/api/v1/solutions/qa/extract-questions", {
    method: "POST",
    token,
    json: { upload_id: uploadId, ...model },
  });
}
